import React from 'react';
import 'Style/navbar.css';
import { Squash as Hamburger } from 'hamburger-react';
import { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useFirebase, isLoaded, isEmpty } from "react-redux-firebase";
import { useSelector } from "react-redux";

export default function Navbar() {
    
    const firebase = useFirebase();
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useSelector((state) => state.firebase.auth);
    // inital state is null to have the menu hidden without any animation on the first load of page
    const [isOpen, setOpen] = useState(null);

    const isAuthenticated = () => {
        return isLoaded(auth) && !isEmpty(auth);
    }

    return (
        <div id="navbar">
          
            <img className="logo-mm" src="https://mooiennietzomooinederland.nl/wp-content/uploads/2023/10/Jorrit-comment-Mooi-of-Niet-zo-mooi-Nederland-just-only-M.svg" alt="Mooi En Niet Zo Mooi Nederland" />
            <img className="logo-menzm" src="https://mooiennietzomooinederland.nl/wp-content/uploads/2024/07/Jorrit-comment-Mooi-of-Niet-zo-mooi-Nederland-just-with-out-Ma1.png" alt="Mooi En Niet Zo Mooi Nederland" />
            <div className="logo-sub">op de kaart</div>

            <div className="navbar-right">
                {/*
                <input className="input-text" type="text" placeholder="Projectcode..." />
                <input className="input-button" type="button" value="Ga" />
                */}
                <Hamburger size={20} toggled={isOpen} toggle={setOpen} ></Hamburger>

            </div>

            <div className={`menu ${isOpen == null ? "menu-hidden" : (isOpen ? "menu-in" : "menu-out")}`}>
                {location.pathname != '/' && 
                    <a className="menuItem" href="#" onClick={() => navigate('/')}>Terug</a>
                }
                {isAuthenticated() && 
                    <a className="menuItem" href="#" onClick={() => navigate('/projects')}>Projecten</a>
                }

                {isAuthenticated() ? 
                    <a className="menuItem" href="#" onClick={() => firebase.logout().then(() => navigate('/'))}>Uitloggen</a>
                :
                    <a className="menuItem" href="#" onClick={() => navigate('/login')}>Beheer</a>
                }
                <a className="menuItem" href="#" onClick={() => navigate('/contact')}>Contact</a>
                </div>
        </div>
    )
}